export enum PromotionPayoutStatus {
    PENDING = 0,
    PAID_OUT = 1,
    FAILED = 2,
    NEW = 3,
}
